import { Model } from 'vue-models'
import DateTime from './types/DateTime'
import TextField from './types/TextField'
import Port from './port'
import ShipmentEvent from './event'
import Vessel from './vessel'

export default class Coords extends Model {
  static defaults () {
    return {
      name: 'shipment',
      basePath: 'shipments/coordinates'
    }
  }
  static schema () {
    return {
      id: { type: Number },
      status: { type: Number },
      status_verbose: { type: TextField },
      weight: { type: Number },
      health: { type: TextField },
      days_in_tsp: { type: TextField },
      days_in_tsp1: { type: Object },
      days_in_tsp2: { type: Object },
      days_in_tsp3: { type: Object },
      days_in_tsp4: { type: Object },
      days_in_pol: { type: Object },
      events: { type: Array, items: { type: ShipmentEvent } },
      container_number: { type: TextField },
      container_type_str: { type: TextField },
      container_type_iso: { type: TextField },
      bl_number: { type: TextField },
      booking_number: { type: TextField },
      bl_or_booking_number: { type: TextField },
      client_code: { type: TextField },
      pol_loc: { type: Port },
      pol_vsldeparture_planned_initial: { type: Object },
      origin_loc: { type: Port },
      empty_pickup_loc: { type: Port },
      pol_arrival_planned_initial: { type: Object },
      pol_arrival_planned_last: { type: Object },
      pol_vsldeparture_planned_last: { type: Object },
      pol_vsldeparture_actual: { type: Object },
      pol_vsldeparture_detected: { type: Object },
      pol_arrival_actual: { type: Object },
      pol_loaded_planned_initial: { type: Object },
      pol_loaded_actual: { type: Object },
      pod_vslarrival_planned_initial: { type: Object },
      pod_vslarrival_planned_last: { type: Object },
      pod_vslarrival_actual: { type: Object },
      pod_vsldeparture_actual: { type: Object },
      pol_loaded_planned_last: { type: Object },
      current_vessel: { type: Vessel },
      current_vessel_position: { type: Object },
      dlv_loc: { type: Port },
      empty_pickup_planned_initial: { type: Object },
      empty_pickup_planned_last: { type: Object },
      origin_pickup_planned_initial: { type: Object },
      origin_pickup_planned_last: { type: Object },
      origin_pickup_actual: { type: Object },
      tsp4_vsldeparture_planned_last: { type: Object },
      tsp4_vsldeparture_actual: { type: Object },
      tsp4_vsldeparture_detected: { type: Object },
      current_vessel_nextport: { type: Object },
      empty_pickup_actual: { type: Object },
      dlv_delivery_planned_initial: { type: Object },
      dlv_delivery_planned_last: { type: Object },
      schema_form: { type: Object },
      sf_data: { type: Object },
      dlv_delivery_actual: { type: Object },
      empty_return_loc: { type: Port },
      empty_return_planned_initial: { type: Object },
      empty_return_planned_last: { type: Object },
      empty_return_actual: { type: Object },
      tsp4_vsldeparture_planned_initial: { type: Object },
      tsp4_loaded_actual: { type: Object },
      tsp4_loaded_planned_last: { type: Object },
      tsp4_loaded_planned_initial: { type: Object },
      pod_vslarrival_detected: { type: Object },
      pod_vslarrival_prediction: { type: Object },
      pod_timeofarrival_warning: { type: Object },
      pod_discharge_planned_initial: { type: Object },
      pod_discharge_planned_last: { type: Object },
      pod_discharge_actual: { type: Object },
      pod_departure_planned_initial: { type: Object },
      pod_departure_planned_last: { type: Object },
      pod_departure_actual: { type: Object },
      tsp1_vslarrival_planned_initial: { type: Object },
      tsp1_vslarrival_planned_last: { type: Object },
      tsp1_vslarrival_actual: { type: Object },
      tsp1_vslarrival_detected: { type: Object },
      tsp1_vslarrival_prediction: { type: Object },
      tsp1_discharge_planned_initial: { type: Object },
      tsp1_discharge_planned_last: { type: Object },
      tsp1_discharge_actual: { type: Object },
      tsp1_loaded_planned_initial: { type: Object },
      tsp1_loaded_planned_last: { type: Object },
      tsp1_loaded_actual: { type: Object },
      tsp1_vsldeparture_planned_initial: { type: Object },
      tsp1_vsldeparture_planned_last: { type: Object },
      tsp1_vsldeparture_actual: { type: Object },
      tsp1_vsldeparture_detected: { type: Object },
      tsp2_vslarrival_planned_initial: { type: Object },
      tsp2_vslarrival_planned_last: { type: Object },
      tsp2_vslarrival_actual: { type: Object },
      tsp2_vslarrival_detected: { type: Object },
      tsp2_vslarrival_prediction: { type: Object },
      tsp2_discharge_planned_initial: { type: Object },
      tsp2_discharge_planned_last: { type: Object },
      tsp2_discharge_actual: { type: Object },
      tsp2_loaded_planned_initial: { type: Object },
      tsp2_loaded_planned_last: { type: Object },
      tsp2_loaded_actual: { type: Object },
      tsp2_vsldeparture_planned_initial: { type: Object },
      tsp2_vsldeparture_planned_last: { type: Object },
      tsp2_vsldeparture_actual: { type: Object },
      tsp2_vsldeparture_detected: { type: Object },
      tsp3_vslarrival_planned_initial: { type: Object },
      tsp3_vslarrival_planned_last: { type: Object },
      tsp3_vslarrival_actual: { type: Object },
      tsp3_vslarrival_detected: { type: Object },
      tsp3_vslarrival_prediction: { type: Object },
      tsp3_discharge_planned_initial: { type: Object },
      tsp3_discharge_planned_last: { type: Object },
      tsp3_discharge_actual: { type: Object },
      tsp3_loaded_planned_initial: { type: Object },
      tsp3_loaded_planned_last: { type: Object },
      tsp3_loaded_actual: { type: Object },
      tsp3_vsldeparture_planned_initial: { type: Object },
      tsp3_vsldeparture_planned_last: { type: Object },
      tsp3_vsldeparture_actual: { type: Object },
      tsp3_vsldeparture_detected: { type: Object },
      tsp4_vslarrival_planned_initial: { type: Object },
      tsp4_vslarrival_planned_last: { type: Object },
      tsp4_vslarrival_actual: { type: Object },
      tsp4_vslarrival_detected: { type: Object },
      tsp4_discharge_planned_initial: { type: Object },
      tsp4_discharge_planned_last: { type: Object },
      tsp4_discharge_actual: { type: Object },
      tsp4_vslarrival_prediction: { type: Object },
      pod_loc: { type: Port },
      eta: { type: DateTime },
      ata: { type: DateTime },
      etd: { type: DateTime },
      atd: { type: DateTime },
      dtd: { type: TextField },
      dta: { type: TextField },
      discrepancy_eta_at_pod: { type: TextField },
      discrepancy_eta_at_dlv: { type: TextField },
      carrier_name: { type: TextField },
      carrier_scac: { type: TextField },
      leg1_voyage: { type: TextField },
      leg2_voyage: { type: TextField },
      leg3_voyage: { type: TextField },
      leg4_voyage: { type: TextField },
      leg5_voyage: { type: TextField },
      leg1_vessel: { type: Vessel },
      leg2_vessel: { type: Vessel },
      leg3_vessel: { type: Vessel },
      leg4_vessel: { type: Vessel },
      leg5_vessel: { type: Vessel },
      lif_loc: { type: Port },
      lif_arrival_actual: { type: DateTime },
      lif_arrival_planned_initial: { type: DateTime },
      lif_arrival_planned_last: { type: DateTime },
      lif_departure_actual: { type: DateTime },
      lif_departure_planned_initial: { type: DateTime },
      lif_departure_planned_last: { type: DateTime },
      availability_loc: { type: Port },
      availability_date: { type: DateTime },
      carrier_release_date: { type: DateTime },
      carrier_release_state: { type: Object },
      customs_release_date: { type: DateTime },
      customs_release_state: { type: Object },
      lifecycle_status: { type: Object },
      lifecycle_status_verbose: { type: Object },
      tsp1_loc: { type: Port },
      tsp2_loc: { type: Port },
      tsp3_loc: { type: Port },
      tsp4_loc: { type: Port },
      last_coordinates: { type: Object, properties: {lng: {type: Number}, lat: {type: Number}} },
      last_update: { type: DateTime },
      last_alert_walltime: { type: DateTime },
      created_at: { type: DateTime },
      modified_at: { type: DateTime },
      warnings: { type: Array, items: { type: TextField } },
      alerts: { type: Array, items: { type: TextField } },
      last_alert_message: { type: TextField },
      last_alert_code: { type: TextField }
    }
  }
  static STATUS_FILTER = {
    invalid: 'Invalid',
    new: 'New',
    ongoing: 'On going',
    archived: 'Archived',
    cancelled: 'Cancelled'
  }
  static HEALTH = {
    ontrack: 'On track',
    delayed: 'Later than expected',
    alerted: 'Attention required'
  }
}



// WEBPACK FOOTER //
// ./src/models/coordinates.js